/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import keyBy from "lodash/fp/keyBy";
import mapValues from "lodash/fp/mapValues";

import { StreamateSites } from "~/constants";
import { GetPromotionSitesResponse } from "~/features/mySites/types";

const transformToPromotedPrograms = (apiData: GetPromotionSitesResponse) => {
  const transformed: Record<number, string[]> = mapValues(() => [], keyBy("siteid", StreamateSites));

  apiData.promotions.forEach((site) => {
    if (!transformed[site.siteid]) {
      transformed[site.siteid] = [];
    }

    transformed[site.siteid].push(site.programname);
  });

  return transformed;
};

export default transformToPromotedPrograms;
